import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEllipsisH, faEye, faList, faPlus} from '@fortawesome/free-solid-svg-icons';
import {Button, ButtonGroup, Card, Col, Dropdown, Image, Row, Table} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import PaginationTable from "../../components/PaginationTable";
import {getUser} from "../../utils/StorageUtil";
import {Link} from "react-router-dom";
import {Routes} from "../../routes";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import queryString from 'query-string';
import SearchInput from "../../components/input/SearchInput";
import TableSortOption from "../../components/input/TableSortOption";
import SortOption from "enqc-utilities/src/model/SortOption";
import {handleTimeAgo, navigate, parseDate} from "enqc-utilities/src/utils/Utilities";
import UserDetailPage from "./UserDetailPage";
import StatusAttribute from "enqc-utilities/src/model/StatusAttribute";
import UserCreationModal from "../../components/UserCreationModal";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";

class UserPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      userCreationModal:false,
      inputSearch: queryString.parse(this.props.query).search ? queryString.parse(this.props.query).search : "",
      user : getUser(),
      page: queryString.parse(props.query).page ? queryString.parse(props.query).page : 1,
      users:[],
      totalPage: 0,
      totalElement: 0,
      pageElement: 0,
      sortOption:{}
    }
  }

  componentDidMount() {
    super.componentDidMount();
    if(this.props?.navBar?.current){
      this.props.navBar.current.updateNavBarItems([UserPage.PAGE_CONF])
    }
    this.closePreLoader()
    this.fetchUsers()
  }

  componentWillReceiveProps(props, nextContext) {
    if (props != this.props) {
      let page = queryString.parse(props.query).page ? queryString.parse(props.query).page : 1
      let key = queryString.parse(props.query).tab ? queryString.parse(props.query).tab : label.All
      let inputSearch = queryString.parse(props.query).search ? queryString.parse(props.query).search : ""
      this.setState({
        page: page,
        key: key,
        inputSearch: inputSearch
      }, () => {
        this.fetchUsers()
      })
    }
  }


  fetchUsers = () => {
    let {user,users, search, sortOption} = this.state
    this.get(Endpoint.API.USERS, {
      params :{
        userId : user.id,
        ascending: sortOption.ascending,
        sortir: sortOption.sortir,
        search: search,
        page: this.state.page - 1,
      }
    }, null, response=>{
      if(response.code===200){
        let users = response.data
        let totalPage = response.totalPage
        let totalElement = response.totalElement
        let pageElement = response.pageElement
        this.setState({users:users,totalPage, totalElement, pageElement})
      }else{
        this.props.history.goBack();
      }
    }, true, true)
  }



  render() {
    let {user, users, page, pageElement, totalPage, totalElement, sortOption,userCreationModal} = this.state
    return (
        <>
          <UserCreationModal
              show={userCreationModal}
              onClose={()=>{
                this.setState({userCreationModal:false})
              }}
              onCreateUser={() => {
                this.setState({userCreationModal:false},() => this.fetchUsers())
              }} showProcessing={this.props.showProcessing} closeProcessing={this.props.closeProcessing}/>
          {this.renderHeader()}
          {this.renderDesktopTable()}
          {this.renderMobileList()}
          {this.renderEmpty()}
          <PaginationTable
              onSelect={(currentPage) => {
                this.setState({page:currentPage},() => {this.fetchUsers()})
              }}
              showingRow={users.length}
              currentPage={page}
              pageCount={totalPage}
              totalElement={totalElement}/>
        </>
    );
  }

  renderHeader(){
    let {user, users, page, pageElement, totalPage, totalElement, sortOption,userCreationModal} = this.state
    return(
        <div className="table-settings ms-md-3 me-md-3">
          <Row className="align-items-center">
            <Col xs={4} sm={4} md={2} lg={1} xl={1} className="ps-md-0 text-left mb-2">
              <TableSortOption
                  sortOptions={
                    [
                      SortOption.init(label.Oldest,"u.created",true),
                      SortOption.init(label.Latest,"u.created",false),
                      SortOption.init(label.Name,"u.firstname",false),
                    ]
                  }
                  sortOption={sortOption}
                  placeholder={label.SortBy}
                  onSelect={(sortOption) => {
                    this.setState({sortOption},() => {
                      this.fetchUsers()
                    })
                  }}
                  onReset={() => {
                    this.setState({sortOption:{}},() => {
                      this.fetchUsers()
                    })
                  }}/>
            </Col>
            <Col xs={12} sm={8} md={6} lg={4} xl={4} className="mb-2">
              <SearchInput
                  onEnter={(search) => {
                    this.setState({search}, () => {
                      this.fetchUsers()
                    })
                  }} onEmpty={() => {
                this.setState({search:""},() => {
                  this.fetchUsers()
                })
              }}/>
            </Col>
          </Row>
        </div>
    )
  }

  renderDesktopTable(){
    let {user, users, page, pageElement, totalPage, totalElement, sortOption,userCreationModal} = this.state
    return(
        <Card border="light" className="table-wrapper table-responsive shadow-sm d-none d-sm-block">
          <Card.Body className="p-0">
            <Table hover className="table-sm align-items-center">
              <thead>
              <tr className="bg-light">
                <th className="border-bottom text-center">#</th>
                <th className="border-bottom">{label.Name}</th>
                <th className="border-bottom">{label.Email}</th>
                <th className="border-bottom">{label.ManufacturingSite}</th>
                <th className="border-bottom">{label.LastAccess}</th>
                <th className="border-bottom">{label.Status}</th>
                <th className="border-bottom">{label.Detail}</th>
              </tr>
              </thead>
              <tbody>
              {users.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal text-center">
                        {((page - 1) * pageElement) + (++index)}
                      </Card.Link>
                    </td>
                    <td>
                      <span className="fw-normal">{item.fullname}</span>
                    </td>
                    <td>
                      <span className="fw-normal">{item.email}</span>
                    </td>
                    <td>
                      <span className="fw-normal">{item.manufacturingSite?item.manufacturingSite.name:"-"}</span>
                    </td>
                    <td>
                      <span className="fw-normal">{item.lastOpenDate?handleTimeAgo(item.lastOpenDate):label.NeverAccessing}</span>
                    </td>
                    <td>
                      <Button variant={"outline-"+StatusAttribute.UserStatus[item.userStatus.toUpperCase()].clazz} size="sm">
                        <img width="18px" src={StatusAttribute.UserStatus[item.userStatus.toUpperCase()].icon}className="me-1" />{item.userStatus}
                      </Button>
                    </td>
                    <td>
                      {
                        user.id!==item.id?(
                            <Button
                                size="sm"
                                className="rounded-circle text-center btn-outline-gray bg-transparent"
                                onClick={(e) => {
                                  e.preventDefault()
                                  navigate(this.props, UserDetailPage.ENDPOINT+"/"+item.userCode)
                                }}
                                type={Link}>
                              <FontAwesomeIcon size="sm" icon={faEye}/>
                            </Button>
                        ):null
                      }
                    </td>
                  </tr>
              ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
    )
  }

  renderMobileList(){
    let {users, page, pageElement, totalPage, totalElement, sortOption,userCreationModal} = this.state
    return(
        <Card className="table-wrapper table-responsive d-block d-md-none bg-transparent border-0">
          {users.map((user, index)=>{
            return(
                <Card.Body
                    style={{backgroundColor:(index+1)%2>0?"#f5f1ea":"#ffffff", cursor:'pointer', border: '1px solid #dee2e6', borderRadius: '0.25rem' }}
                    onClick={event => {
                      event.preventDefault()
                        navigate(this.props, UserDetailPage.ENDPOINT+"/"+user.userCode)
                    }}
                    className="p-0 mb-2">
                  <table className="w-100">
                    <tr className="w-100 d-table-row">
                      <td style={{whiteSpace:'nowrap', width:'8%'}} rowSpan="3" className="text-center align-items-center align-content-center bg-primary text-white fs-9 fw-bold ps-2 pe-2 rounded-start">
                        #{((page - 1) * pageElement) + (index+1)}
                      </td>
                      <td
                          colSpan={2}
                          style={{whiteSpace:'nowrap', width:'92%'}}
                          className="bg-white ps-2 pe-2 border-bottom">
                        <div className="d-flex align-content-center align-items-center">
                          <span className="text-left fw-bold text-success fs-7 p-0 w-100">{user.fullname}</span>
                          <span className="text-right font-italic text-green fs-9 p-0 w-100">{parseDate(user.updated, DD_MMMM_YYYY_HH_MM_SS)}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" className="ps-2 pe-2">
                        <span className="fs-7 fw-bold text-dark text-wrap">{user.email}</span>
                      </td>
                    </tr>
                    <tr className="w-100">
                      <td className="text-left ps-2" rowSpan="2">
                        <span className="fs-6 fw-bold text-info">{user.manufacturingSite.name}</span>
                        <br/>
                        {label.Role}: <span className="text-italic text-dark fs-8 text-uppercase">{user.userRole.name}</span>
                      </td>
                      <td className="align-items-center align-content-center pe-2 text-end">
                        <Button style={{fontSize:'14px'}} className="p-1 fs-9" variant={"outline-"+StatusAttribute.UserStatus[user.userStatus.toUpperCase()].clazz} size="sm">
                          <img width="14px" src={StatusAttribute.UserStatus[user.userStatus.toUpperCase()].icon}className="me-1" />{user.userStatus}
                        </Button>
                      </td>
                    </tr>
                  </table>
                </Card.Body>
            )
          })}
        </Card>
    )
  }
  renderEmpty(){
    let {users}= this.state
    if(!users){
      users = []
    }

    if(users.length<=0){
      return (
          <Card className="mb-3">
            <Card.Body>
              <div className="w-100 h-100 text-center align-content-center justify-content-center align-items-center" style={{minHeight:'200px'}}>
                <Image
                    className="p-1"
                    style={{
                      width: '150px',
                      height: '150px',
                      objectFit: 'cover',
                      opacity: 0.2,
                      filter : 'blur(1px)'
                    }}
                    src={ApplicationIcons.Icons.emptyBox}/>
                <br/>
                <span>Empty data..</span>
              </div>
            </Card.Body>
          </Card>
      )
    }
    return(null)
  }



}
// export default Object.assign(UserPage, {ENDPOINT : "/users"})
const ENDPOINT = "/users"
const TITLE = label.UserList
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(UserPage, PAGE)


